// import
import Dashboard from "views/Dashboard/Dashboard";
import Tables from "views/Dashboard/Tables";
import Add from "views/Dashboard/Add";
import Billing from "views/Dashboard/Billing";
import RTLPage from "views/Dashboard/RTL";
import Profile from "views/Dashboard/Profile";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,HelpIcon
} from "components/Icons/Icons";
import { FaPlus } from "react-icons/fa";
import { Icon } from "@chakra-ui/react";
var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/add",
    name: "Add new Document",
    icon: <Icon style={{ margin: '0px' }} as={FaPlus} fontSize='lg' mb='12px' />,//<RocketIcon color="inherit" />,
    component: Add,
    layout: "/admin",
  },
  {
    path: "/edit/:document_id",
    name: "Edit Document",
    icon: <Icon style={{ margin: '0px' }} as={FaPlus} fontSize='lg' mb='12px' />,//<RocketIcon color="inherit" />,
    component: Tables,
    layout: "/admin",
  },
     {
       path: "/documentation",
       name: "Documentation",
       icon: <HelpIcon color="inherit" />,
       component: Profile,
       layout: "/admin",
     }
];
export default dashRoutes;
